/**
 * [Insider+] Membership-management page — hosts the iframe at /membership.
 */

import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { INSIDER_PLUS_BASE_URL } from '../security/config';
import InsiderPlusIframeShell from '../components/InsiderPlus/InsiderPlusIframeShell';
import useInsiderPlusIframe from '../util/hooks/useInsiderPlusIframe';

const InsiderPlusMembershipPage = () => {
  const history = useHistory();

  const buildIframeSrc = useCallback(
    () => `${INSIDER_PLUS_BASE_URL}/membership`,
    [],
  );

  // Same-origin targets (e.g. iframe breadcrumb back to /investor-hub) go
  // through react-router so the parent tree doesn't full-reload. External
  // URLs (e.g. Discourse forum) fall back to window.location.href.
  const onNavigateUrl = useCallback(
    (url) => {
      try {
        const target = new URL(url, window.location.origin);
        if (target.origin === window.location.origin) {
          history.push(target.pathname + target.search + target.hash);
          return;
        }
      } catch {
        // Malformed URL — fall through to full-page navigation
      }
      window.location.href = url;
    },
    [history],
  );

  const {
    iframeRef,
    iframeSrc,
    iframeKey,
    isRecovering,
    authFailed,
    isRetrying,
    handleIframeLoad,
    handleRetry,
  } = useInsiderPlusIframe({ buildIframeSrc, onNavigateUrl });

  return (
    <InsiderPlusIframeShell
      iframeRef={iframeRef}
      iframeSrc={iframeSrc}
      iframeKey={iframeKey}
      title="Investor Hub Membership"
      dataCy="container-insider-plus-membership-page"
      isRecovering={isRecovering}
      authFailed={authFailed}
      isRetrying={isRetrying}
      onIframeLoad={handleIframeLoad}
      onRetry={handleRetry}
    />
  );
};

export default InsiderPlusMembershipPage;
